import { ApiPlugin } from '@/plugins';

export default class PhoneBook {
  static getServices() {
    try {
      if (window?.drupalSettings?.['phone-book-page']) {
        return {
          elements: window.drupalSettings['phone-book-page'].elements,
          scenario: window.drupalSettings['phone-book-page'].cas,
          label: window.drupalSettings['phone-book-page'].label,
          phones: window.drupalSettings['phone-book-page'].phones,
        };
      }
    } catch (e) {
      console.log(e);
    }
    return {};
  }

  static getQuestionsAnswers() {
    if (window.drupalSettings?.sante_directory_pages?.parameters?.[0]) {
      const res = window.drupalSettings?.sante_directory_pages?.parameters?.[0];
      const tree = Object.values(res.tree)[0];
      return {
        ...{
          ...tree, key: Object.keys(res.tree)[0], answerTitle: tree.title, answerDescription: tree.description,
        },
        ...res,
      };
    }
    return {};
  }

  static async getLikelyContent({
    nid = window.drupalSettings.webform.dialog.entity_id, type = 'professionnel_de_sante', story = 1,
  }) {
    const response = await ApiPlugin.get(`/api/related-content?nid=${nid}&type=${type}&story=${story}`);
    return response.data;
  }
}
